import ThmZoneInfoPanel from 'thm/ui/common/zone/ThmZoneInfoPanel'
import ZoneWorkstationInfoPanelTplStache from 'thm/ui/common/zone/ZoneWorkstationInfoPanelTpl.stache'

/**
 * @class ZoneWorkstationInfoPanel
 * Workstation form
 */
let ZoneWorkstationInfoPanel = ThmZoneInfoPanel.extend({
  id: 'zoneWorkstationInfoPanel',
  childTpl: ZoneWorkstationInfoPanelTplStache,
})

export default ZoneWorkstationInfoPanel
